import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pageable, SecondaryUserFilter, SFSOptions, User, WorkflowDataService } from '@nimmsta/ng-commons-lib';
import { serializeUserRolesForRequest } from '@nimmsta/ng-commons-lib';

@Injectable({ providedIn: 'root' })
export class OrganizationUserService extends WorkflowDataService<User> {
  private orgId?: string;
  public secondaryUserFilter = SecondaryUserFilter.WITH_SECONDARY_USERS;

  protected override get apiEndpoint(): string {
    return '/user';
  }

  public setOrgId(orgId: string): void {
    this.orgId = orgId;
  }

  private getOrgApiEndpoint(): string {
    return `/organization/${this.orgId}/user`;
  }

  override list(options: Partial<SFSOptions> = {}): Observable<Pageable<User>> {
    let params = this.getParams(options);
    params = params.append('secondaryUserFilter', this.secondaryUserFilter);
    return this.http.get<Pageable<User>>(this.baseUrl + this.getOrgApiEndpoint(), {
      params,
    });
  }

  override create(user: User): Observable<User> {
    const createUser = {
      firstName: user.given_name,
      lastName: user.family_name,
      email: user.email,
      roles: serializeUserRolesForRequest(user.roles ?? [user.role]),
    };
    return this.http.post<User>(`${this.baseUrl + this.getOrgApiEndpoint()}`, createUser);
  }

  override update(user: User): Observable<User> {
    const editUser = {
      firstName: user.given_name,
      lastName: user.family_name,
      email: user.email,
      organizationId: user.organization?.id,
      ...(user.roles !== undefined
        ? { roles: serializeUserRolesForRequest(user.roles) }
        : {}),
    };
    return this.http.put<User>(`${this.baseUrl + this.getOrgApiEndpoint()}/${user.id}`, editUser);
  }

  override delete(user: User): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl + this.getOrgApiEndpoint()}/${user.id}`);
  }

  lock(user: User): Observable<void> {
    return this.http.post<void>(`${this.baseUrl + this.getOrgApiEndpoint()}/${user.id}/lock`, {});
  }

  unlock(user: User): Observable<void> {
    return this.http.post<void>(`${this.baseUrl + this.getOrgApiEndpoint()}/${user.id}/unlock`, {});
  }

  removeSecondaryOrg(userId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl + this.apiEndpoint}/${userId}/secondary-orgs/${this.orgId}`);
  }
}
